export const environment = {
    production: false,
    apiBaseUrl: 'https://testapi.vishwarang.com/api/',
    SiteBaseUrl: 'https://testapi.vishwarang.com/',    
    // apiBaseUrl: 'http://localhost:5091/api/',    
    // SiteBaseUrl: 'http://localhost:5091/',       
    appID:'testolympiad.vishwarang.com-2F77DE06B949314357F2128B9D175105',    
    appDomain:'OLYMPIAD', 
    gaMeasurementId: 'G-MHFWRTLLC1',    
    MERCHANT_KEY:"2A77D06M949314357F2128B9M17510N",
    defaultDailCode:"+91",
    OTP_WAITING_SECOND:120,
    AppLanguageCodes:['EN','HI'],
    AppDefaultLanguageCode : 'EN',
    INDIA_COUNTRY_ID:101,
    RazorJsLibraryUrl:'https://checkout.razorpay.com/v1/checkout.js', 
    PayUPaymentLibraryUrl:'https://jssdk-uat.payu.in/bolt/bolt.min.js'  
};
